import fetch from "lib/fetch";
import type { ScholarSubjectInterface } from "types/reference";

type ScholarSubjectListResponse = { data: Array<ScholarSubjectInterface> };

export const getScholarSubjectsRequest = (languageCode: string) =>
    fetch.get<ScholarSubjectListResponse>(`reference/scholar_subject/${languageCode}`);
